import React from 'react';
import { TextField } from 'material-ui';

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...this.state })
    })
      .then(() => alert('Success!'))
      .catch(error => alert(error));
    e.preventDefault();
  };

  render() {
    return (
      <div
        style={{
          backgroundColor:'white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 100,
          padding:100
        }}
      >
        <p>Feel free to send me a message if you got some questions</p>
        <form
          name="contact"
          method="post"
          action="/thanks/"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={this.handleSubmit}
        >
          <p hidden>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>

          <TextField
            id="with-placeholder"
            name={'name'}
            label="Name"
            placeholder="John Snow"
            type="text"
            required
            onChange={this.handleChange}
          />
          <br />
          <TextField
            id="with-placeholder"
            name={'email'}
            label="Email"
            placeholder="xxxx@xxxx.com"
            type="text"
            required
            onChange={this.handleChange}
          />
          <br />
          <TextField
            id="multiline-static"
            name={'message'}
            label="Message"
            multiline
            rows="4"
            margin="normal"
            required
            onChange={this.handleChange}
          />
          <p>
            <button type="submit">Send</button>
          </p>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact.js